import { Component, input } from '@angular/core';
import { NgpFormField, NgpLabel } from 'ng-primitives/form-field';

export type JoiiCheckboxFormFieldVerticlePosition = 'top' | 'bottom' | 'center';

@Component({
  selector: 'joii-checkbox-form-field',
  imports: [NgpFormField, NgpLabel],
  styles: `
    [ngpFormField] {
      display: flex;
      align-items: center;
      gap: var(--Vetai-Spacing-2-5);
    }

    [ngpFormField].vertical-position-top {
      align-items: flex-start;
    }

    [ngpFormField].vertical-position-bottom {
      align-items: flex-end;
    }

    [ngpFormField].vertical-position-center {
      align-items: center;
    }

    [ngpFormField].disabled {
      cursor: not-allowed;
    }

    [ngpLabel] {
      color: var(--Vetai-Texts--Base);
      font-weight: var(--Vetai-Font-Weight-Regular);
      font-size: var(--Vetai-T4);
      line-height: var(--Vetai-20);
      font-family: var(--Vetai-Font-Family);
      letter-spacing: var(--Vetai-8-16);
      font-kerning: none;
      font-style: normal;
    }

    [ngpLabel].disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,
  template: `
    <div
      ngpFormField
      [class.vertical-position-top]="verticalPosition() === 'top'"
      [class.vertical-position-center]="verticalPosition() === 'center'"
      [class.vertical-position-bottom]="verticalPosition() === 'bottom'"
      [class.disabled]="disabled()"
    >
      <ng-content select="[slot=checkbox]" />
      @if (label()) {
        <label ngpLabel [class.disabled]="disabled()">{{ label() }}</label>
      }
    </div>
  `,
})
export class CheckboxFormFieldComponent {
  label = input<string>('');
  disabled = input<boolean>(false);
  verticalPosition = input<JoiiCheckboxFormFieldVerticlePosition>('center');
}
